module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "box-body form-center"
  }, [_c('div', [(_vm.activity.strategy_data.rule_code === 'SA00001') ? _c('h4', [_vm._v("消費金額滿額")]) : (_vm.activity.strategy_data.rule_code === 'SA00002') ? _c('h4', [_vm._v("消費商品數量滿額")]) : (_vm.activity.strategy_data.rule_code === 'SA00003') ? _c('h4', [_vm._v("指定商品滿額")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "box-body form-center"
  }, [(_vm.activity.strategy_data.rule_code === 'SA00001') ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activity.strategy_data.setting.money_unit),
      expression: "activity.strategy_data.setting.money_unit"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "贈送條件達成金額",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.activity.strategy_data.setting.money_unit)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activity.strategy_data.setting, "money_unit", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.activity.strategy_data.rule_code === 'SA00002' || _vm.activity.strategy_data.rule_code === 'SA00003') ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activity.strategy_data.setting.amount_unit),
      expression: "activity.strategy_data.setting.amount_unit"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "贈送條件達成商品數",
      "type": "text",
      "maxlength": "20"
    },
    domProps: {
      "value": (_vm.activity.strategy_data.setting.amount_unit)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activity.strategy_data.setting, "amount_unit", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.activity.strategy_data.rule_code === 'SA00002') ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("商品限制最低單價(單位：元)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activity.strategy_data.setting.lowest_unit_price),
      expression: "activity.strategy_data.setting.lowest_unit_price"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "商品限制最低單價",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.activity.strategy_data.setting.lowest_unit_price)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activity.strategy_data.setting, "lowest_unit_price", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("每次贈送最大份數")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activity.strategy_data.setting.max_count),
      expression: "activity.strategy_data.setting.max_count"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "每次贈送最大份數",
      "type": "text",
      "maxlength": "20"
    },
    domProps: {
      "value": (_vm.activity.strategy_data.setting.max_count)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activity.strategy_data.setting, "max_count", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('hr', {
    staticClass: "box-body"
  }), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "box-body form-left"
  }, [_c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                  訂單類型\n                ")]), _vm._v(" "), _c('div', [_c('multiselect', {
    attrs: {
      "options": _vm.orderType,
      "searchable": false,
      "allow-empty": true,
      "close-on-select": false,
      "placeholder": "訂單類型",
      "show-labels": false,
      "multiple": true,
      "label": "label",
      "track-by": "label"
    },
    model: {
      value: (_vm.activity.strategy_data.limit.order_type),
      callback: function($$v) {
        _vm.$set(_vm.activity.strategy_data.limit, "order_type", $$v)
      },
      expression: "activity.strategy_data.limit.order_type"
    }
  })], 1)]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                  訂單方案\n                ")]), _vm._v(" "), _c('div', [_c('multiselect', {
    attrs: {
      "options": _vm.orderMethod,
      "searchable": true,
      "allow-empty": true,
      "close-on-select": false,
      "placeholder": "訂單方案",
      "show-labels": false,
      "multiple": true,
      "label": "label",
      "track-by": "label"
    },
    model: {
      value: (_vm.activity.strategy_data.limit.order_method),
      callback: function($$v) {
        _vm.$set(_vm.activity.strategy_data.limit, "order_method", $$v)
      },
      expression: "activity.strategy_data.limit.order_method"
    }
  })], 1)]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("訂單最低應付金額(單位：元)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activity.strategy_data.limit.min_total_paid_money),
      expression: "activity.strategy_data.limit.min_total_paid_money"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "包含扣除折價",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.activity.strategy_data.limit.min_total_paid_money)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activity.strategy_data.limit, "min_total_paid_money", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("訂單最低總金額(單位：元)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activity.strategy_data.limit.min_total_money),
      expression: "activity.strategy_data.limit.min_total_money"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.activity.strategy_data.limit.min_total_money)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activity.strategy_data.limit, "min_total_money", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("訂單最低購買數(單位：個)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activity.strategy_data.limit.min_total_amount),
      expression: "activity.strategy_data.limit.min_total_amount"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.activity.strategy_data.limit.min_total_amount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activity.strategy_data.limit, "min_total_amount", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "box-body form-right"
  }, [_c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                  取貨方式\n                ")]), _vm._v(" "), _c('div', [_c('multiselect', {
    attrs: {
      "options": _vm.deliveryType,
      "searchable": false,
      "allow-empty": true,
      "close-on-select": false,
      "placeholder": "取貨方式",
      "show-labels": false,
      "multiple": true,
      "label": "label",
      "track-by": "label"
    },
    model: {
      value: (_vm.activity.strategy_data.limit.delivery_type),
      callback: function($$v) {
        _vm.$set(_vm.activity.strategy_data.limit, "delivery_type", $$v)
      },
      expression: "activity.strategy_data.limit.delivery_type"
    }
  })], 1)]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                  付款地點\n                ")]), _vm._v(" "), _c('div', [_c('multiselect', {
    attrs: {
      "options": _vm.payPlaceType,
      "searchable": false,
      "allow-empty": true,
      "close-on-select": false,
      "placeholder": "付款地點",
      "show-labels": false,
      "multiple": true,
      "label": "label",
      "track-by": "label"
    },
    model: {
      value: (_vm.activity.strategy_data.limit.pay_place_type),
      callback: function($$v) {
        _vm.$set(_vm.activity.strategy_data.limit, "pay_place_type", $$v)
      },
      expression: "activity.strategy_data.limit.pay_place_type"
    }
  })], 1)]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("限制主單(或團長)最低總金額(單位：元)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activity.strategy_data.limit.min_money),
      expression: "activity.strategy_data.limit.min_money"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.activity.strategy_data.limit.min_money)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activity.strategy_data.limit, "min_money", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("限制主單(或團長)最低購買數(單位：個)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activity.strategy_data.limit.min_amount),
      expression: "activity.strategy_data.limit.min_amount"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.activity.strategy_data.limit.min_amount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activity.strategy_data.limit, "min_amount", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("限制子單(跟團單)最低訂單數(單位：筆)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activity.strategy_data.limit.min_sub_order_amount),
      expression: "activity.strategy_data.limit.min_sub_order_amount"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.activity.strategy_data.limit.min_sub_order_amount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activity.strategy_data.limit, "min_sub_order_amount", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "box-body form-center",
    staticStyle: {
      "padding-top": "0px"
    }
  }, [_c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("限制主單(或團長)最低應付金額(單位：元)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activity.strategy_data.limit.min_paid_money),
      expression: "activity.strategy_data.limit.min_paid_money"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "包含扣除折價",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.activity.strategy_data.limit.min_paid_money)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activity.strategy_data.limit, "min_paid_money", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('hr', {
    staticClass: "box-body"
  }), _vm._v(" "), _c('div', {
    staticClass: "box-body form-center"
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [(_vm.ruleCode === 'SA00001' || _vm.ruleCode === 'SA00002') ? _c('h5', [_vm._v("例外商品選擇")]) : _c('h5', [_vm._v("指定商品選擇")])]), _vm._v(" "), _c('div', {}, [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [(_vm.ruleCode === 'SA00003') ? _c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]) : _vm._e(), _vm._v("選擇參與店家菜單")]), _vm._v(" "), _c('multiselect', {
    attrs: {
      "options": _vm.storeList,
      "searchable": true,
      "allow-empty": false,
      "close-on-select": true,
      "placeholder": "店家",
      "show-labels": false,
      "multiple": false,
      "label": "label",
      "track-by": "label"
    },
    model: {
      value: (_vm.storeSelect),
      callback: function($$v) {
        _vm.storeSelect = $$v
      },
      expression: "storeSelect"
    }
  })], 1), _vm._v(" "), _c('br')]), _vm._v(" "), (_vm.ruleCode === 'SA00001') ? _c('menu-discount', {
    attrs: {
      "menuId": _vm.menuSelect.value,
      "showWord": '排除'
    },
    on: {
      "addProdToList": _vm.addExProdToList
    }
  }) : (_vm.ruleCode === 'SA00002') ? _c('menu-discount', {
    attrs: {
      "menuId": _vm.menuSelect.value,
      "showWord": '加入'
    },
    on: {
      "addProdToList": _vm.addExProdToList2
    }
  }) : (_vm.ruleCode === 'SA00003') ? _c('menu-discount', {
    attrs: {
      "menuId": _vm.menuSelect.value,
      "showWord": '排除'
    },
    on: {
      "addProdToList": _vm.addProdToList
    }
  }) : _vm._e(), _vm._v(" "), (_vm.activity.strategy_data.store_exception_items[0].products.length && (_vm.ruleCode === 'SA00001' || _vm.ruleCode === 'SA00002')) ? _c('div', {
    staticClass: "m-t-10"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable"
  }, [_vm._m(3), _vm._v(" "), _c('tbody', _vm._l((_vm.activity.strategy_data.store_exception_items[0].products), function(aProduct, aIndex) {
    return _c('tr', [_c('td', [_vm._v("\n              " + _vm._s(aIndex + 1) + "\n            ")]), _vm._v(" "), _c('td', [_vm._v("\n              " + _vm._s(aProduct.product_name) + "\n            ")]), _vm._v(" "), _c('td', [_c('div', [_vm._v(_vm._s(aProduct.vendor_custom_id))])]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-danger",
      on: {
        "click": function($event) {
          return _vm.removeListItem(_vm.activity.strategy_data.store_exception_items[0].products, aIndex)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])])])
  }), 0)])]) : _vm._e(), _vm._v(" "), (_vm.activity.strategy_data.setting.vendor_custom_product_list.length && _vm.ruleCode === 'SA00003') ? _c('div', {
    staticClass: "m-t-10"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable"
  }, [_vm._m(4), _vm._v(" "), _c('tbody', _vm._l((_vm.activity.strategy_data.setting.vendor_custom_product_list), function(aProduct, aIndex) {
    return _c('tr', [_c('td', [_vm._v("\n              " + _vm._s(aIndex + 1) + "\n            ")]), _vm._v(" "), _c('td', [_vm._v("\n              " + _vm._s(aProduct.product_name) + "\n            ")]), _vm._v(" "), _c('td', [_c('div', [_vm._v(_vm._s(aProduct.vendor_custom_id))])]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-danger",
      on: {
        "click": function($event) {
          return _vm.removeListItem(_vm.activity.strategy_data.setting.vendor_custom_product_list, aIndex)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])])])
  }), 0)])]) : _vm._e()], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("贈送條件達成金額(單位：元)")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("贈送條件達成商品數(單位：個)")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-body form-center"
  }, [_c('div', [_c('h4', [_vm._v("限制規則")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "bg-primary"
  }, [_c('tr', [_c('td', [_vm._v("＃")]), _vm._v(" "), _c('td', [_vm._v("商品")]), _vm._v(" "), _c('td', [_vm._v("商品料號")]), _vm._v(" "), _c('td')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "bg-primary"
  }, [_c('tr', [_c('td', [_vm._v("＃")]), _vm._v(" "), _c('td', [_vm._v("商品")]), _vm._v(" "), _c('td', [_vm._v("商品料號")]), _vm._v(" "), _c('td')])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5e8a5f92"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Marketing/Temp/ActivityStrategy.vue
// module id = 2446
// module chunks = 1